(() => {
  const money = (cents) => {
    if (cents == null || cents === "") return "";
    const n = Number(cents) / 100;
    return `$${n.toFixed(2)}`;
  };

  document.querySelectorAll("[data-lp-product-form]").forEach((form) => {
    const root = form.closest(".lp-buybox") || document;
    const idInput = form.querySelector("[data-lp-variant-id]");
    const saleEl = root.querySelector("[data-lp-sale]");
    const compareEl = root.querySelector("[data-lp-compare]");
    const currentLabel = root.querySelector("[data-fp-current]");
    const mainImg = root.querySelector("[data-lp-main-img]");

    root.querySelectorAll("[data-fp-tile]").forEach((tile) => {
      tile.addEventListener("click", () => {
        root.querySelectorAll("[data-fp-tile]").forEach((t) => t.classList.remove("is-selected"));
        tile.classList.add("is-selected");
        if (idInput) idInput.value = tile.dataset.variantId || idInput.value;
        if (currentLabel) currentLabel.textContent = tile.dataset.fpLabel || "";
        if (saleEl) saleEl.textContent = money(tile.dataset.price);
        if (compareEl) {
          const c = Number(tile.dataset.compare || 0);
          const p = Number(tile.dataset.price || 0);
          if (c > p) {
            compareEl.hidden = false;
            compareEl.textContent = money(c);
          } else {
            compareEl.hidden = true;
          }
        }
        if (mainImg && tile.dataset.image) mainImg.src = tile.dataset.image;
      });
    });

    root.querySelectorAll("[data-lp-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        root.querySelectorAll("[data-lp-thumb]").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
        if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      });
    });
  });

  const modal = document.querySelector("[data-lp-nl-modal]");
  if (modal) {
    document.querySelectorAll("[data-lp-nl-open]").forEach((btn) => {
      btn.addEventListener("click", () => {
        modal.hidden = false;
      });
    });
    modal.querySelectorAll("[data-lp-nl-close]").forEach((btn) => {
      btn.addEventListener("click", () => {
        modal.hidden = true;
      });
    });
    modal.querySelectorAll("[data-nl-tab]").forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.getAttribute("data-nl-tab");
        modal.querySelectorAll("[data-nl-tab]").forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");
        modal.querySelectorAll("[data-nl-pane]").forEach((pane) => {
          pane.hidden = pane.getAttribute("data-nl-pane") !== key;
        });
      });
    });
  }

  // Soft-replace leftover emails in static sections
  const walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walk.nextNode()) nodes.push(walk.currentNode);
  nodes.forEach((n) => {
    if (n.nodeValue && /@drinkliquidplus\.com/i.test(n.nodeValue)) {
      n.nodeValue = n.nodeValue.replace(/[\w.+-]+@drinkliquidplus\.com/gi, "qjbv7733@outlook.com");
    }
    if (n.nodeValue && n.nodeValue.includes("®")) {
      n.nodeValue = n.nodeValue.replace(/®/g, "");
    }
  });
})();
